import React from "react";
import { HERO_STATS } from "../mock";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const Hero = () => {
  return (
    <section id="top" className="relative min-h-screen flex items-center grid-bg overflow-hidden pt-28">
      {/* ambient glows */}
      <div className="pointer-events-none absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full bg-gold/5 blur-[120px]" />
      <div className="pointer-events-none absolute bottom-0 right-0 w-[500px] h-[500px] rounded-full bg-gold/5 blur-[130px]" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-8 w-full">
        <div className="max-w-3xl reveal">
          <span className="inline-flex items-center gap-2 border border-gold/30 bg-gold/5 px-4 py-2 font-ui text-[10px] md:text-[11px] tracking-[0.25em] uppercase text-gold">
            <span className="h-1.5 w-1.5 rounded-full bg-gold" />
            TwinBrain Jewellery · Nagpur, Maharashtra
          </span>

          <h1 className="font-display smallcaps mt-8 leading-[0.92] text-white">
            <span className="block text-6xl md:text-8xl">Pure</span>
            <span className="block text-6xl md:text-8xl gold-gradient-text">Gold &amp; Silver</span>
            <span className="block font-body italic text-4xl md:text-6xl text-gray-200 mt-3 tracking-normal normal-case" style={{ fontVariant: 'normal' }}>Coins, Crafted for You</span>
          </h1>

          <p className="font-body italic text-lg md:text-xl text-gray-400 mt-8 max-w-xl leading-relaxed">
            Own certified precious metal coins — backed by trust, delivered with elegance. Join India's most rewarding scheme.
          </p>

          <div className="flex flex-wrap gap-3 mt-10">
            {HERO_STATS.map((s, i) => (
              <div key={i} className="border border-white/10 bg-white/[0.03] px-5 py-3 min-w-[92px] text-center card-glow">
                <div className="font-display text-2xl md:text-3xl text-gold">{s.value}</div>
                <div className="font-ui text-[9px] tracking-[0.2em] uppercase text-muted-foreground mt-1">{s.label}</div>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap gap-4 mt-10">
            <button onClick={() => scrollTo('#scheme')} className="gold-btn font-ui text-xs tracking-[0.2em] uppercase px-8 py-4 font-medium transition-all hover:shadow-lg hover:shadow-gold/20">
              Join Reward Scheme
            </button>
            <button onClick={() => scrollTo('#coins')} className="border border-white/20 text-white font-ui text-xs tracking-[0.2em] uppercase px-8 py-4 hover:border-gold hover:text-gold transition-colors">
              Explore Coins →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
